<mat-card appearance="outlined">
    <mat-card-content>
        @if (isEditing) {
            <div>
                @for (code of allowedLangCodes; track code) {
                    <sl-input
                        type="text"
                        placeholderKey="GeneralSettings.Language{{ getCode(code) }}"
                        [control]="formGroup.controls[code]" />
                }
            </div>
        }
        <div [hidden]="isEditing">
            <video #streamPlayer class="video-js" controls muted playsinline preload="none"></video>
        </div>
    </mat-card-content>
    @if (canEdit) {
        <mat-card-actions>
            @if (!isEditing) {
                <button mat-button (click)="isEditing = true">
                    <mat-icon>edit</mat-icon>
                    {{ 'General.Edit' | translate }}
                </button>
            }
            @if (isEditing) {
                <button mat-button [disabled]="isSaving" (click)="save()">
                    <mat-icon>save</mat-icon>
                    {{ 'General.Save' | translate }}
                </button>
            }
        </mat-card-actions>
    }
</mat-card>
